import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const invoiceReferenceNumberTypesAdapter = getAdapter({ idFieldName: 'value' });

const invoiceReferenceNumberTypesSlice = createSlice({
  name: 'invoiceReferenceNumberTypes',
  initialState: invoiceReferenceNumberTypesAdapter.getInitialState(),
  reducers: {
    setInvoiceReferenceNumberTypes: (state, { payload: { invoiceReferenceNumberTypes } }) => {
      invoiceReferenceNumberTypesAdapter.setAll(state, invoiceReferenceNumberTypes);
    },
  },
});

const selectors = invoiceReferenceNumberTypesAdapter.getSelectors(({ invoiceReferenceNumberTypes }) => invoiceReferenceNumberTypes);

export const getInvoiceReferenceNumberTypes = (state) => selectors.selectAll(state);

export const {
  setInvoiceReferenceNumberTypes,
} = invoiceReferenceNumberTypesSlice.actions;

export default invoiceReferenceNumberTypesSlice.reducer;
